import { render, staticRenderFns } from "./LiYaDeLabelDialog.vue?vue&type=template&id=27fb84cf&scoped=true"
import script from "./LiYaDeLabelDialog.vue?vue&type=script&lang=js"
export * from "./LiYaDeLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./LiYaDeLabelDialog.vue?vue&type=style&index=0&id=27fb84cf&prod&scoped=true&lang=css"
import style1 from "./LiYaDeLabelDialog.vue?vue&type=style&index=1&id=27fb84cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb84cf",
  null
  
)

export default component.exports